'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

export default ['$scope', '$routeParams', '$window', '$uibModalInstance', '$uibModal', 'planFundByYear', 'edit',
                function($scope, $routeParams, $window, $modalInstance, $modal, planFundByYear, edit) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.edit = edit;

                    $scope.planFundByYear = angular.copy(planFundByYear);
                    $scope.planFundByYear.amount = 0;

                    function ok() {
                        $modalInstance.close(
                            $scope.planFundByYear
                        );
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }
                }];
